import {Button, Grid} from '@mui/material';
import React from 'react';
import {Box} from '@mui/system';
import {useSnackbar} from 'notistack';
import withAutoFormNew from '../../components/AutoForm/AutoFormNew';
import AutoField from '../../components/AutoForm/AutoFieldNew';
import {
  ReportPackGenericFormType,
  reportPackFormType,
  ReportPackGenericFormInnerType,
  reportPackSIPPNumberField,
} from './ReportPackFields';
import {useAutoForm} from '../../components/AutoForm/useAutoForm';

import {useReportPack} from './useReportPack';
import {getReportPackMissingFieldError} from './getReportPackMissingFieldError';
import {ReportPackFormFragment} from '../../schema-types/ReportPackFormFragment';

export const ReportPackExpressionOfWishes: React.FC<ReportPackGenericFormType> = ({
  formData,
  onClose,
  disabled,
}) => {
  const {enqueueSnackbar, closeSnackbar} = useSnackbar();
  const {onUpsertExpressionOfWishesForm} = useReportPack();
  return (
    <ReportPackExpressionOfWishesFormWrapped
      formFields={[]}
      disabled={disabled}
      submit={async (values) => {
        if (disabled) {
          return;
        }
        closeSnackbar();
        enqueueSnackbar(`Saving ${formData.formTypeLabel}...`, {
          variant: 'info',
        });
        await onUpsertExpressionOfWishesForm({
          variables: {
            contactCuroId: values.contactCuroId,
            reportPackId: String(formData.reportPackId),
            formId: formData.id,
            sippNumber: values.sippNumber,
          },
        })
          .then(({data}) => {
            if (data?.upsertExpressionOfWishesForm?.ok) {
              closeSnackbar();
              enqueueSnackbar(`Successfully saved ${formData.formTypeLabel}`, {
                variant: 'success',
              });
              onClose();
            } else {
              throw Error(data?.upsertExpressionOfWishesForm?.errors?.join(','));
            }
          })
          .catch((err) => {
            closeSnackbar();
            enqueueSnackbar(`Could not save ${formData.formTypeLabel} ${err}`, {
              variant: 'error',
            });
          });
      }}
      initialValueOverrides={{
        ...formData,
        reportPackId: String(formData.reportPackId),
        contactCuroId: String(formData.contactCuroId),
      }}
    />
  );
};

const ReportPackExpressionOfWishesForm: React.FC<ReportPackGenericFormInnerType> = ({
  disabled,
}) => {
  const {submitForm, isSubmitting, values} = useAutoForm<ReportPackFormFragment>();

  return (
    <Box maxWidth={500}>
      <Grid container p={2} mb={2} spacing={2} direction="column">
        <Grid item>
          <AutoField
            readOnly={disabled}
            error={getReportPackMissingFieldError(values, reportPackSIPPNumberField.id)}
            field={reportPackSIPPNumberField}
          />
        </Grid>
      </Grid>
      <Box position="absolute" bottom={20} right={20}>
        {!disabled && (
          <Button
            variant="contained"
            color="secondary"
            disabled={isSubmitting}
            onClick={() => submitForm()}
          >
            Save form
          </Button>
        )}
      </Box>
    </Box>
  );
};

const ReportPackExpressionOfWishesFormWrapped = withAutoFormNew<
  reportPackFormType,
  ReportPackGenericFormInnerType
>(ReportPackExpressionOfWishesForm, {}, {debugPosition: 'bottom'});
